import './ForgotPassword.less';

export const prefix = 'bm-c-forgot';

export { default } from './ForgotPassword';
